
export const fetchSurveysStart = (state, payload) => {
    return {
        ...state,
        surveyListApi: {
            isProcessing: true,
            error: false,
            data: false
        }
    };
}

export const fetchSurveysSuccess = (state, payload, searchText) => {
    let projectCount = payload.total
    if (searchText !== '' && payload.total === 0) {
        projectCount = 1
    }
    return {
        ...state,
        projectCount: projectCount,
        surveyListApi: {
            lastsearchText: searchText,
            isProcessing: false,
            data: true,
            surveyList: payload.hits,
            count: payload.total
        },
    };
}

export const fetchSurveysFail = (state, payload) => {
    return {
        ...state,
        surveyListApi: {
            isProcessing: false,
            error: true,
            data : false
        },
    };
};